module.exports = __webpack_public_path__ + "static/media/ico-error.a4261e8c.svg";